import { type SetAppDataAction, SET_APP_DATA } from '../../../actions/app/index.tsx';
import {
	SET_CARD_ORDER_GLOBAL,
	type SetCardOrderGlobalAction,
} from '../../../actions/card-order-global/index.tsx';
import {
	CARDS_MOVE_REQUEST,
	type CardsMoveRequestAction,
} from '../../../actions/cards/move/index.tsx';
import type { CardOrderGlobalState } from './types.tsx';

type Action = SetAppDataAction | SetCardOrderGlobalAction | CardsMoveRequestAction;

const cardOrderGlobalReducer = (state: CardOrderGlobalState = [], action: Action) => {
	if (action.type === SET_APP_DATA) {
		return action.payload.entities.cardOrderGlobal || state;
	}

	if (action.type === SET_CARD_ORDER_GLOBAL) {
		return action.payload;
	}

	if (action.type === CARDS_MOVE_REQUEST) {
		return action.payload.newCardOrderGlobal || state;
	}

	return state;
};

export default cardOrderGlobalReducer;
